<template>
  <div class="comnavBack">
    <div class="comnavBack_navBack">
      <div class="" @click="handleBack()">
        <img src="@/assets/images/fanhui.png" alt="" class="comnavBack_navBack_left_img" />
      </div>
      <div class="comnavBack_navBack_text">
        {{ title }}
      </div>
      <div class="comnavBack_navBack_right">
        <img src="@/assets/images/tianjia.png" alt="" class="comnavBack_navBack_right" v-if="isShow" @click="goAdd" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navBack",
  props: {
    title: {
      type: String,
      default: "GTH介绍",
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    // 是否跳转到页面
    isOnePage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleBack() {
      if (this.isOnePage) {
        this.$router.go(-1);
      } else {
        this.$emit("handleBack");
      }
    },
    goAdd() {
      this.$emit("handleGo");
    },
  },
};
</script>

<style></style>